import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { ProductoService } from '../../servicios/producto.service'
import { Router } from '@angular/router';

@Component({
  selector: 'app-marcas',
  templateUrl: './marcas.component.html',
  styleUrls: ['./marcas.component.scss']
})
export class MarcasComponent implements OnInit {

  constructor(
		public globals: Globals,
		private productoService: ProductoService,
		private router: Router,
  ) { }

  seleccionarMarca( marca ){
    this.globals.configuracion.front.listado.marca = marca.idmarca;
    this.globals.setDataFront();

    this.router.navigate(['/modelos']);
  }

  marcas = {
    cargando: true,
    registros: new Array()
  }

  marcasListado(){
    this.marcas.cargando = true;

    this.productoService.marcasListado({
      categoria: this.globals.configuracion.front.listado.categoria
    }).subscribe(
      resultado =>{
        if( !resultado.error ){
          if( resultado.registros.length == 0 ){
            this.router.navigate(['/catalogo']);
            return ;
          }
          Array.prototype.push.apply( this.marcas.registros, resultado.registros );
          this.marcas.cargando = false;
        }else{
          console.log("Error",resultado.mensaje);
        }

      },
      error =>{
        console.log("Error",error);
        //this.feedProductos.cargando = false;
      }
    )
  }

  ngOnInit(): void {
    this.globals.configuracion.front.listado.modelo = '';
    this.globals.setDataFront();
    this.marcasListado();
  }

}
